import React from "react"
import { css } from "styled-components"
import { Block, Spacer } from "../atoms/layout-primitives"
import Link from "../atoms/link"
import VariantContainer from "../atoms/variant-container"
import { BT } from "../styles/blog-typography"
import Text from "../atoms/text"
import Divider from "../atoms/divider"

interface IArticleRowTitleProps {
  title: string
  url?: string
  linkText?: string
}

const ArticleRowTitle = ({
  title,
  url,
  linkText = "See All",
}: IArticleRowTitleProps) => {
  return (
    <Block>
      <Text
        as="h3"
        variants={[
          css`
            display: inline;
            padding-right: 12px;
            ${BT.sm.h3`500`};
          `,
          css`
            padding-right: 16px;
            ${BT.md.h3`500`};
          `,
        ]}
      >
        {title}
      </Text>
      {url && (
        <VariantContainer
          variants={[
            css`
              display: inline;
              ${BT.sm.info`400`};
              color: var(--burnt-orange);
              a {
                text-decoration: none;
                color: inherit;
              }
            `,
          ]}
        >
          <Link to={url}>{linkText}</Link>
        </VariantContainer>
      )}
      <Spacer height={{ sm: "16px" }} />
      <Divider />
    </Block>
  )
}

export default ArticleRowTitle
